import { useEffect } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import BlogHero from './components/BlogHero';
import BlogContent from './components/BlogContent';

export default function BlogSoftwareCosts() {
  useEffect(() => {
    // Update meta tags
    document.title = 'Stop Paying for Licenses: The Hidden Savings of Outsourcing Your Construction Tech | Dinari Designs';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Discover how Vancouver contractors eliminate AutoCAD and Bluebeam subscription costs by outsourcing layout work and converting software expenses into project value.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'AutoCAD subscription costs, Bluebeam licensing, construction software expenses, Vancouver contractor savings, outsourcing technology costs');
    }

    // Add Schema.org JSON-LD for Article
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: 'Stop Paying for Licenses: The Hidden Savings of Outsourcing Your Construction Tech',
      description: 'Discover how Vancouver contractors eliminate AutoCAD and Bluebeam subscription costs by outsourcing layout work and converting software expenses into project value.',
      author: {
        '@type': 'Organization',
        name: 'Dinari Designs',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Dinari Designs',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.readdy.ai/image/f0c3f25d25166b296c2998ed1e07db56/4ed16d38f79ad8245b8fcfc88558374a.jfif',
        },
      },
      datePublished: '2026-02-05',
      dateModified: new Date().toISOString().split('T')[0],
    });

    if (!document.head.querySelector('script[data-schema="blog-software-costs"]')) {
      script.setAttribute('data-schema', 'blog-software-costs');
      document.head.appendChild(script);
    }

    return () => {
      const schemaScript = document.head.querySelector('script[data-schema="blog-software-costs"]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <BlogHero />
      <BlogContent />
      <Footer />
    </div>
  );
}
